export const HR_MANAGER = "HR Manager";
export const SHIFT_SUPERVISOR = "ShiftSupervisor";